import { render } from "./App.vue?vue&type=template&id=63c1d444"
const script = {}

import "./App.vue?vue&type=style&index=0&id=63c1d444&lang=less"

import exportComponent from "../../firstwindow_xz_vue/node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__